const INPUT_CLASS =
    "input-dark auth-input w-full rounded-md px-4 text-base sm:text-sm text-white placeholder:text-white/35 focus:placeholder:opacity-0";

/** Consistent auth input styling — matches SaaS login card. */
export function AuthFormInput({ className = "", ...props }) {
    return <input {...props} className={`${INPUT_CLASS} ${className}`.trim()} />;
}
